const stages = [
  {
    num: '01',
    icon: 'ri-search-eye-line',
    title: 'Диагностика компетенций',
    desc: 'Анализ текущего уровня знаний и навыков сотрудников по ключевым ролям. Выявление сильных сторон и зон роста. Интервью с руководителями, оценка 360°, тестирование.',
    details: ['Аудит текущих процессов обучения', 'Оценка компетенций ключевых сотрудников', 'Выявление критических разрывов в навыках', 'Формирование карты потребностей в обучении'],
  },
  {
    num: '02',
    icon: 'ri-grid-line',
    title: 'Матрица компетенций',
    desc: 'Создание матрицы компетенций для каждой роли: какие знания и навыки необходимы на каждом уровне. Основа для построения карты обучения и оценки.',
    details: ['Описание hard и soft skills по ролям', 'Уровни владения: базовый / уверенный / экспертный', 'Связь компетенций с бизнес-показателями', 'Основа для индивидуальных планов развития'],
  },
  {
    num: '03',
    icon: 'ri-road-map-line',
    title: 'Карта обучения',
    desc: 'Проектирование образовательных траекторий для каждой роли: чему учить, в каком порядке, с какой периодичностью. Карта обучения связывает компетенции с конкретными программами.',
    details: ['Образовательные треки по должностям', 'Последовательность модулей и программ', 'Форматы: тренинги, бизнес-игры, e-learning', 'Календарный план на год'],
  },
  {
    num: '04',
    icon: 'ri-file-text-line',
    title: 'Программы обучения',
    desc: 'Разработка содержания: тренинги, бизнес-игры, кейсы, чек-листы, видеоуроки. Каждая программа привязана к конкретным компетенциям и бизнес-задачам.',
    details: ['Авторские методики и материалы', 'Адаптация под специфику компании', '80% практики, реальные кейсы', 'Рабочие тетради и чек-листы'],
  },
  {
    num: '05',
    icon: 'ri-user-voice-line',
    title: 'Наставничество',
    desc: 'Подготовка внутренних наставников из числа опытных сотрудников. Регламенты работы наставников, система мотивации и оценки эффективности.',
    details: ['Отбор и обучение наставников', 'Регламент и чек-листы наставника', 'Система мотивации наставников', 'Оценка эффективности наставничества'],
  },
  {
    num: '06',
    icon: 'ri-tools-fill',
    title: 'Практика и внедрение',
    desc: 'Отработка навыков на реальных задачах. Домашние задания, полевые сопровождения, разбор результатов. 80% обучения — практика.',
    details: ['Полевое сопровождение руководителей', 'Разбор реальных кейсов компании', 'Домашние задания с проверкой', 'Посттренинговые встречи'],
  },
  {
    num: '07',
    icon: 'ri-bar-chart-grouped-line',
    title: 'Оценка и аналитика',
    desc: 'Регулярная оценка прогресса: тестирование, оценка руководителя, KPI. Данные для корректировки программ и подтверждения ROI обучения.',
    details: ['Промежуточное тестирование', 'Оценка 180° и 360°', 'Сравнение KPI до и после обучения', 'Ежеквартальные отчёты'],
  },
  {
    num: '08',
    icon: 'ri-loop-left-line',
    title: 'Повторное развитие',
    desc: 'Цикл не заканчивается. По результатам оценки — корректировка программ, повышение уровня компетенций, новые цели. Академия развивается вместе с бизнесом.',
    details: ['Корректировка матрицы компетенций', 'Обновление программ обучения', 'Повышение уровня сложности', 'Новые направления развития'],
  },
];

export default function AcademyStructure() {
  return (
    <section id="structure" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Из чего состоит современная корпоративная академия
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Восемь элементов, которые превращают хаотичное обучение в работающую систему развития персонала
        </p>

        <div className="space-y-8">
          {stages.map((stage, i) => (
            <div key={i} className="bg-white rounded-2xl p-6 md:p-8 border border-gray-200 hover:border-teal-300 transition-all">
              <div className="flex flex-col md:flex-row gap-6">
                {/* Number and icon */}
                <div className="flex md:flex-col items-center gap-3 md:w-32 flex-shrink-0">
                  <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className={`${stage.icon} text-xl text-white`}></i>
                  </div>
                  <span className="text-4xl font-extrabold text-teal-600/20 md:mt-2">{stage.num}</span>
                </div>

                {/* Content */}
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{stage.title}</h3>
                  <p className="text-gray-600 leading-relaxed mb-4">{stage.desc}</p>
                  <div className="grid sm:grid-cols-2 gap-2">
                    {stage.details.map((d, j) => (
                      <div key={j} className="flex items-start gap-2 text-sm text-gray-600">
                        <span className="w-1.5 h-1.5 bg-teal-600 rounded-full flex-shrink-0 mt-2"></span>
                        <span>{d}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Arrow to next stage */}
              {i < stages.length - 1 && (
                <div className="flex justify-center mt-6">
                  <div className="w-10 h-10 bg-teal-100 rounded-full flex items-center justify-center">
                    <i className="ri-arrow-down-line text-teal-600"></i>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}